import { render, staticRenderFns } from "./GraphDetail35.vue?vue&type=template&id=53e904f4&scoped=true"
import script from "./GraphDetail35.vue?vue&type=script&lang=js"
export * from "./GraphDetail35.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e904f4",
  null
  
)

export default component.exports